import { get, patch, post, remove } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  actions: {
    retrieveItems: (_, data) => {
      return new Promise((resolve, reject) => {
        get(`/${data.apiRoute}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // e.g. get(`/devices-of-person/${idPerson}`)
    retrieveItemsOfParent: (_, data) => {
      return new Promise((resolve, reject) => {
        get(`/${data.apiRoute}/${data.idParent}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    retrieveItem: (_, data) => {
      return new Promise((resolve, reject) => {
        get(`/${data.apiRoute}/${data.id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    store: (_, data) => {
      return new Promise((resolve, reject) => {
        post(`/${data.apiRoute}`, data.dataForDatabase)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    update: (_, data) => {
      return new Promise((resolve, reject) => {
        patch(`/${data.apiRoute}/${data.id}`, data.dataForDatabase)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    remove: (_, data) => {
      return new Promise((resolve, reject) => {
        remove(`/${data.apiRoute}/${data.id}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
